// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import DateField from "../../ui/DateField";
import TimeField from "../../ui/TimeField";
import Button from "../../ui/Button";
import { showError, showMessage } from "../../ui/Message";
import { bm_date, bm_time } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import dayjs from "dayjs";
import DateInput from "../../ui/DateInput";

export default function RangeConditional(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, include_time = false, include_compare = false, edit = false } = props;

    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }


    let fromPart = "";
    let toPart = "";

    if (include_compare) {
        if (filter?.value_1) {
            const [first, second] = filter.value_1.split("|");
            fromPart = first || "";
            toPart = second || "";
        }
    } else {
        fromPart = filter?.value_1 || "";
        toPart = filter?.value_2 || "";
    }




    // parse time if included
    let fromDate = fromPart;
    let fromTime = "";
    let toDate = toPart;
    let toTime = "";

    if (include_time) {
        if (fromPart.includes(" ")) {
            [fromDate, fromTime] = fromPart.split(" ");
        }
        if (toPart.includes(" ")) {
            [toDate, toTime] = toPart.split(" ");
        }
    }


    const fields = [
        { include: true, label: "date_from", key: "date_from", value: (edit) ? fromDate : "", help: "Enter date MM/DD/YY (PgUp for today, -12 months, -180 days and -90 days)" },
        { include: include_time, label: "date_from_time", key: "date_from_time", value: (edit) ? fromTime : "", help: "Enter time. eg 15:00 or 3pm" },
        { include: true, label: "date_to", key: "date_to", value: (edit) ? toDate : "", help: "Enter date MM/DD/YY (PgUp for today, -12 months, -180 days and -90 days)" },
        { include: include_time, label: "date_to_time", key: "date_to_time", value: (edit) ? toTime : "", help: "Enter time. eg 15:00 or 3pm" },
        { include: include_compare, key: "comparison", value: (edit) ? filter?.comparison : "=", help: "= equal, < less, > greater" },
        { include: include_compare, key: "value_2", value: (edit) ? filter?.value_2 : "0", help: "Enter the data to complete this filter." },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];


    const save = (tabs) => {
        const comparison = (include_compare) ? tabs.find(f => f.key === "comparison").value : "";


        const _date_from = tabs.find(f => f.key === "date_from")?.value || "";
        const _date_from_time = tabs.find(f => f.key === "date_from_time")?.value || "";
        const _date_to = tabs.find(f => f.key === "date_to")?.value || "";
        const _date_to_time = tabs.find(f => f.key === "date_to_time")?.value || "";

        // check required dates
        if (!_date_from || !_date_to) {
            showError({ error: "Both 'date_from' and 'date_to' must be provided." })
            return;
        }

        // build parts
        const fromPart = bm_date(_date_from, "YYYY-MM-DD") + (include_time && bm_time(_date_from_time, false) ? " " + bm_time(_date_from_time, false) : "");
        const toPart = bm_date(_date_to, "YYYY-MM-DD") + (include_time && bm_time(_date_to_time, false) ? " " + bm_time(_date_to_time, false) : "");

        // final string

        let value_1 = "";
        let value_2 = "";
        if (include_compare) {
            value_2 = tabs.find(f => f.key === "value_2").value;
            value_1 = `${fromPart}|${toPart}`;
        } else {
            value_1 = `${fromPart}`;
            value_2 = `${toPart}`;
        }


        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
            value_1: value_1,
            value_2: value_2.toString()
        }



        onSave(_f, filter);
    }

    return (
        <FilterBase controller={controller} fields={fields.filter(item => item.include)} onClose={() => onClose()} onSave={save}>
            {({ editProps, update, tabs, next }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <DateInput cycle={["today", dayjs().add(-12, "months").format("YYYY-MM-DD"), dayjs().add(-180, "days").format("YYYY-MM-DD"), dayjs().add(-90, "days").format("YYYY-MM-DD")]} onFilled={(e) => { update("date_from", e); next() }} shrink={false} width={95} {...editProps("date_from")} />
                        {(include_time && <TimeField shrink={false} width={50} {...editProps("date_from_time")} />)}
                        <div>and</div>
                        <DateInput cycle={["today", dayjs().add(-12, "months").format("YYYY-MM-DD"), dayjs().add(-180, "days").format("YYYY-MM-DD"), dayjs().add(-90, "days").format("YYYY-MM-DD")]} onFilled={(e) => { update("date_to", e); next() }} shrink={false} width={95} {...editProps("date_to")} />
                        {(include_time && <TimeField shrink={false} width={50} {...editProps("date_to_time")} />)}
                        {(include_compare && <div>is</div>)}
                        {(include_compare && <Input {...editProps("comparison")} chars={[">", "<", "="]} maxLength={1} width={20} />)}
                        {(include_compare && <Input {...editProps("value_2")} number maxLength={3} width={35} />)}
                        <Button onClick={() => save(tabs)} {...editProps("save")}>Save</Button>
                    </Space>
                </div>
            )}

        </FilterBase>
    );
}
